import { useSelector } from "react-redux"
import { Outlet } from "react-router-dom"
import { useState } from "react"
import Sidebar from "../component/core/Dashboard/Sidebar"

function Dashboard() {
  const { loading: profileLoading } = useSelector((state) => state.profile)
  const { loading: authLoading } = useSelector((state) => state.auth)
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  if (profileLoading || authLoading) {
    return (
      <div className="grid min-h-[calc(100vh-4rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }

  return (
    <div className="relative flex min-h-[calc(100vh-4rem)]">
      {/* Sidebar */}
      <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />

      {/* Main Content */}
      <div className="h-[calc(100vh-4rem)] flex-1 overflow-auto">
        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Dashboard
